import { cn } from "@/lib/utils";
import { Link, useMatch } from "@tanstack/react-router";
import clsx from "clsx";
import { PlusIcon } from "lucide-react";
import { HomeIcon, MenuIcon, UserIcon, WalletIcon } from "../../ui/icons";

const HomeNavigation = () => {
	const homeMatch = useMatch({
		from: "/main/home",
		shouldThrow: false,
	});

	const cardMatch = useMatch({
		from: "/main/card",
		shouldThrow: false,
	});

	const activityMatch = useMatch({
		from: "/main/activity",
		shouldThrow: false,
	});

	const settingMatch = useMatch({
		from: "/main/setting",
		shouldThrow: false,
	});

	const isDepositRoute = useMatch({
		from: "/main/deposit",
		shouldThrow: false,
	});

	const isDepositAmountRoute = useMatch({
		from: "/main/deposit/$cardId/amount",
		shouldThrow: false,
	});

	const isOnboardingRoute = useMatch({
		from: "/main/onboarding",
		shouldThrow: false,
	});

	if (isDepositRoute || isDepositAmountRoute || isOnboardingRoute) {
		return null;
	}

	return (
		<>
			<div className="pb-20"></div>
			<div className="fixed bottom-0 left-1/2 -translate-x-1/2 z-50 w-full bg-white  h-navbarHeight ">
				<div className="max-w-[800px] mx-auto h-full">
					<div className="flex items-center justify-around px-4  h-full ">
						<Link
							to="/main/home"
							className={clsx(
								"flex flex-col items-center h-10 w-10 justify-center rounded-2xl",
								homeMatch ? "bg-primary-100 " : "bg-white",
							)}
						>
							<HomeIcon
								className={cn("fill-primary-200", {
									"fill-primary-600": homeMatch,
								})}
							/>
						</Link>
						<Link
							to="/main/card"
							className={clsx(
								"flex flex-col items-center h-10 w-10 justify-center rounded-2xl",
								cardMatch ? "bg-primary-100" : "bg-white",
							)}
						>
							<WalletIcon
								className={cn("fill-primary-200 ", {
									"fill-primary-600": cardMatch,
								})}
							/>
						</Link>
						<Link
							to="/main/deposit"
							style={{
								boxShadow: "0px 22px 30px 2px rgba(116, 98, 147, 0.28)",
							}}
							className="flex items-center justify-center w-20 h-20 -mt-10 text-white border-8 border-gray-100 rounded-full  bg-primary-600 [&_svg]:size-6"
						>
							<PlusIcon />
						</Link>
						<Link
							to="/main/activity"
							className={clsx(
								"flex flex-col items-center h-10 w-10  justify-center rounded-2xl",
								activityMatch ? "bg-primary-100" : "bg-white",
							)}
						>
							<MenuIcon
								className={cn("fill-primary-200", {
									"fill-primary-600": activityMatch,
								})}
							/>
						</Link>
						<Link
							to="/main/setting"
							data-testid={"nav-to-setting"}
							className={clsx(
								"flex flex-col items-center h-10 w-10 justify-center rounded-2xl",
								settingMatch ? "bg-primary-100" : "bg-white",
							)}
						>
							<UserIcon
								className={cn("fill-primary-200", {
									"fill-primary-600": settingMatch,
								})}
							/>
						</Link>
					</div>
				</div>
			</div>
		</>
	);
};

export default HomeNavigation;
